import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Table } from '../../util';
import { Loader } from '../../util/Loader';
import { DeleteButton } from '../../util/buttons';
import userAccessFolderParticipationsService from '../../services/user_access_folder_participations.service';
import userAccessFileParticipationsService from '../../services/user_access_file_participations.service';
import claimGroupService from '../../services/claim_group.service';
export default function FoldersAndFilesUserAccessesList(_ref) {
  let {
    userAccess,
    loading,
    setLoading,
    claimGroup,
    setClaimGroup,
    onClaimScheduleClientContactParticipationChange
  } = _ref;
  console.log('FoldersAndFilesUserAccessesList: user Access:: ', userAccess);
  const {
    t
  } = useTranslation();
  const [localUserAccess, setLocalUserAccess] = useState(userAccess);
  useEffect(() => {
    setLocalUserAccess(userAccess);
  }, [userAccess]);
  const deleteUserAccessFolderParticipation = userAccessFolderParticipationsService.useDeleteUserAccessFolderParticipationFromClaimGroup(claimGroup, setClaimGroup, setLoading);
  const deleteUserAccessFileParticipation = userAccessFileParticipationsService.useDeleteUserAccessFileParticipationFromClaimGroup(claimGroup, setClaimGroup, setLoading);
  const onDeleteFolder = async participation => {
    try {
      await deleteUserAccessFolderParticipation(localUserAccess, participation, participation.folder_id);
      const cg = await claimGroupService.get(claimGroup.id);
      const updatedUserAccess = cg.user_accesses.find(ua => ua.id === userAccess.id);
      setLocalUserAccess(updatedUserAccess);
      onClaimScheduleClientContactParticipationChange && (await onClaimScheduleClientContactParticipationChange());
    } finally {
      setLoading(false);
    }
  };
  const onDeleteFile = async participation => {
    try {
      await deleteUserAccessFileParticipation(localUserAccess, participation, participation.folder_file_id);
      const cg = await claimGroupService.get(claimGroup.id);
      const updatedUserAccess = cg.user_accesses.find(ua => ua.id === userAccess.id);
      setLocalUserAccess(updatedUserAccess);
      onClaimScheduleClientContactParticipationChange && (await onClaimScheduleClientContactParticipationChange());
    } finally {
      setLoading(false);
    }
  };
  const headers = [{
    text: t('name')
  }, {
    text: t('type')
  }, {
    text: t('remove_access')
  }];
  const rows = [...(localUserAccess.user_access_folder_participations || []).map(participation => {
    var _participation$folder;
    return {
      key: "folder-".concat(participation.id),
      columns: [((_participation$folder = participation.folder) === null || _participation$folder === void 0 ? void 0 : _participation$folder.name) || participation.folder_id, t('folder'), /*#__PURE__*/React.createElement("div", {
        className: "d-flex justify-content-center",
        key: "delete-folder"
      }, /*#__PURE__*/React.createElement(DeleteButton, {
        onClick: () => onDeleteFolder(participation)
      }))]
    };
  }), ...(localUserAccess.user_access_file_participations || []).map(participation => {
    var _participation$folder2;
    return {
      key: "file-".concat(participation.id),
      columns: [((_participation$folder2 = participation.folder_file) === null || _participation$folder2 === void 0 ? void 0 : _participation$folder2.name) || participation.folder_file_id, t('file'), /*#__PURE__*/React.createElement("div", {
        className: "d-flex justify-content-center",
        key: "delete-file"
      }, /*#__PURE__*/React.createElement(DeleteButton, {
        onClick: () => onDeleteFile(participation)
      }))]
    };
  })];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", null, t('current_access')), loading && /*#__PURE__*/React.createElement(Loader, null), !loading && /*#__PURE__*/React.createElement(Table, {
    headers: headers,
    rows: rows
  }));
}